import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import "./HomeReels.css";
import { FileUpload } from "primereact/fileupload";

function HomeReels() {
  let emptyHomeReel = {
    id: null,
    videoUrl: "",
    thumbnailUrl: "",
    sortOrder: null,
  };
  const [HomeReels, setHomeReels] = useState(null);

  const [HomeReelsDialog, setHomeReelsDialog] = useState(false);
  const [DeleteHomeReel, setDeleteHomeReel] = useState(false);
  const [DeleteHomeReelsDialog, setDeleteHomeReelsDialog] = useState(false);
  const [HomeReel, setHomeReel] = useState(emptyHomeReel);
  const [selectedHomeReels, setSelectedHomeReels] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const [file, setFile] = useState(null);
  const [Imagefile, setImageFile] = useState(null);
  const dt = useRef(null);

  const isFetched = useRef(false);

  useEffect(() => {
    if (!isFetched.current) {
      getHomeReels();
      isFetched.current = true; // Ensure it only runs once
    }
  }, []);
  const getHomeReels = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/HomePageVideos"
      );

      if (response.data) {
        setHomeReels(response.data);
      }
    } catch (error) {
      console.error("Error fetching Videos:", error);
    }
  };

  const openNew = () => {
    setHomeReel(emptyHomeReel);
    setSubmitted(false);
    setHomeReelsDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setHomeReelsDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteHomeReel(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteHomeReelsDialog(false);
  };

  const saveService = async () => {
    setLoading(true);
    setSubmitted(true);

    try {
      let _HomeReels = [...HomeReels];
      let _HomeReel = { ...HomeReel };

      if (HomeReel.id) {
        const index = findIndexById(HomeReel.id);

        let formData = new FormData();
        formData.append("Id", HomeReel.id);
        formData.append(
          "SortOrder",
          isNaN(parseInt(_HomeReel.sortOrder))
            ? 1
            : parseInt(_HomeReel.sortOrder)
        );
        if (Imagefile != null) {
          formData.append("ThumbnailUrl", Imagefile);
        }
        if (file != null) {
          formData.append("VideoUrl", file);
        }

        const response = await axios.put(
          process.env.REACT_APP_BACKEND_URL +
            "api/HomePageVideos/" +
            HomeReel.id,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if (response.data.success) {
          _HomeReels[index] = _HomeReel;
          if (response.data.fileName !== "")
            _HomeReels[index].thumbnailUrl = response.data.fileName;
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Video Updated",
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Video Not Updated",
            life: 3000,
          });
        }
      } else {
        _HomeReel.id = createId();
        let formData = new FormData();

        formData.append(
          "SortOrder",
          isNaN(parseInt(_HomeReel.sortOrder))
            ? 1
            : parseInt(_HomeReel.sortOrder)
        );
        if (Imagefile != null) {
          formData.append("ThumbnailUrl", Imagefile);
        }
        formData.append("VideoUrl", file);
        const response = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "api/HomePageVideos",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if (response.data.success) {
          _HomeReels.push(response.data.homeVideo);
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Video Added",
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Video Not Added",
            life: 3000,
          });
        }
      }

      setHomeReels(_HomeReels);
      setHomeReelsDialog(false);
      setHomeReel(emptyHomeReel);
    } catch (error) {
      console.error("Error during save operation:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail:
          "An error occurred while saving the list content. Please try again later.",
        life: 3000,
      });
    } finally {
      setLoading(false);
      setFile(null);
      setImageFile(null);
    }
  };

  const editProduct = (HomeReel) => {
    setHomeReel({ ...HomeReel });
    setHomeReelsDialog(true);
  };

  const confirmDeleteProduct = (HomeReel) => {
    setHomeReel(HomeReel);
    setDeleteHomeReel(true);
  };

  const deleteProduct = async () => {
    setLoading(true);
    try {
      const response = await axios.delete(
        process.env.REACT_APP_BACKEND_URL + "api/HomePageVideos/" + HomeReel.id
      );

      setLoading(false);

      if (response.data.success) {
        let _HomeReels = HomeReels.filter((val) => val.id !== HomeReel.id);
        setHomeReels(_HomeReels);
        setDeleteHomeReel(false);
        setHomeReel(emptyHomeReel);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Video Deleted",
          life: 3000,
        });
      } else {
        throw new Error("Unexpected response");
      }
    } catch (error) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Video Not Deleted",
        life: 3000,
      });
    }
  };

  const onFileUpload = async (event) => {
    setLoading(true);
    const file = event.files[0];

    setFile(file);

    setHomeReel((prevProductImage) => ({
      ...prevProductImage,
      videoUrl: process.env.REACT_APP_BACKEND_URL_VIDEOS + file.name, // Save the file name as the image path for simplicity
    }));
    setLoading(false);
  };
  const onImageFileUpload = async (event) => {
    setLoading(true);
    const file = event.files[0];

    setImageFile(file);

    setHomeReel((prevProductImage) => ({
      ...prevProductImage,
      thumbnailUrl: process.env.REACT_APP_BACKEND_URL_IMAGES + file.name, // Save the file name as the image path for simplicity
    }));
    setLoading(false);
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < HomeReels.length; i++) {
      if (HomeReels[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteHomeReelsDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedHomeReels.map((HomeReel) => HomeReel.id);
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "api/HomePageVideos/DeleteByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _HomeReels = HomeReels.filter(
        (val) => !selectedHomeReels.includes(val)
      );
      setHomeReels(_HomeReels);
      setDeleteHomeReelsDialog(false);
      setSelectedHomeReels(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Videos Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Videos Not Deleted",
        life: 3000,
      });
    }
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _HomeReel = { ...HomeReel };

    _HomeReel[`${name}`] = val;

    setHomeReel(_HomeReel);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage Home Videos</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={!selectedHomeReels || !selectedHomeReels.length}
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Product Icons</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        style={{ borderRadius: "10px" }}
        onClick={hideDialog}
      />
      <Button
        label="Save"
        loading={loading}
        style={{ borderRadius: "10px" }}
        icon="pi pi-check"
        onClick={saveService}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );
  const imageBodyTemplate = (rowData) => {
    return (
      <img
        loading="lazy"
        src={process.env.REACT_APP_BACKEND_URL_IMAGES + rowData.thumbnailUrl}
        alt={rowData.thumbnailUrl}
        className="shadow-2 border-round"
        style={{ width: "64px" }}
      />
    );
  };
  return (
    <div className="col-12">
      <div className="HomeReel-container">
        <Toast ref={toast} />
        <div className="card">
          <Toolbar
            className="mb-3"
            start={leftToolbarTemplate}
            end={rightToolbarTemplate}
          ></Toolbar>

          <DataTable
            ref={dt}
            value={HomeReels}
            selection={selectedHomeReels}
            onSelectionChange={(e) => setSelectedHomeReels(e.value)}
            dataKey="id"
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 25]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Product Icons"
            globalFilter={globalFilter}
            header={header}
          >
            <Column selectionMode="multiple" exportable={false}></Column>
            <Column
              field="id"
              header="Code"
              sortable
              width="150px"
              style={{ textAlign: "center" }}
            ></Column>
            <Column
              field="thumbnailUrl"
              header="Video Poster"
              body={imageBodyTemplate}
            ></Column>
            <Column
              field="sortOrder"
              header="Order"
              sortable
              style={{ textAlign: "center" }}
            ></Column>

            <Column
              body={actionBodyTemplate}
              exportable={false}
              style={{ minWidth: "12rem" }}
            ></Column>
          </DataTable>
        </div>

        <Dialog
          visible={HomeReelsDialog}
          style={{ width: "32rem" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="HomeReel Details"
          modal
          className="p-fluid"
          footer={productDialogFooter}
          onHide={hideDialog}
        >
          <div className="field">
            <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
              Order :
            </label>
            <InputText
              id="sortOrder"
              type="number"
              value={HomeReel.sortOrder ?? 1}
              onChange={(e) => onInputChange(e, "sortOrder")}
              required
              className={classNames({
                "p-invalid": submitted && !HomeReel.sortOrder,
              })}
            />
          </div>
          <div className="field">
            <label htmlFor="image" className="mt-3 mb-1 font-bold">
              Poster :
            </label>
            <FileUpload
              name="image"
              mode="basic"
              accept="image/*"
              onSelect={onImageFileUpload}
            />
          </div>
          <div className="field">
            <label htmlFor="Video" className="mb-3 font-bold">
              Video
            </label>
            <FileUpload
              name="Video"
              mode="basic"
              accept="video/*,video/mp4,video/mov"
              // Adjust the maximum file size as needed
              onSelect={onFileUpload}
            />
          </div>
        </Dialog>

        <Dialog
          visible={DeleteHomeReel}
          style={{ width: "32rem" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="Confirm"
          modal
          footer={deleteProductDialogFooter}
          onHide={hideDeleteProductDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle mr-3"
              style={{
                textAlign: "center",
                fontSize: "2rem",
                width: "100%",
                color: "#6659ff",
              }}
            />
            <div>
              <p style={{ textAlign: "center", marginBottom: "5px" }}>
                Are you sure you want to delete:
              </p>
              {HomeReel && (
                <p style={{ textAlign: "center", marginBottom: "0" }}>
                  <b>{HomeReel.title}</b>
                </p>
              )}
            </div>
          </div>
        </Dialog>

        <Dialog
          visible={DeleteHomeReelsDialog}
          style={{ width: "32rem" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="Confirm"
          modal
          footer={deleteProductsDialogFooter}
          onHide={hideDeleteProductsDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle mr-3"
              style={{
                textAlign: "center",
                fontSize: "2rem",
                width: "100%",
                color: "#6659ff",
              }}
            />
            {HomeReel && (
              <p
                style={{
                  textAlign: "center",
                  marginTop: "10px",
                  marginBottom: "25px",
                }}
              >
                Are you sure you want to delete the selected Videos?
              </p>
            )}
          </div>
        </Dialog>
      </div>
    </div>
  );
}

export default HomeReels;
